import FormText from '@klv/atoms/form-text';

import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/formField.module.scss';

import type { IFormText } from '@klv/atoms/form-text/types';
import type { IDescription, IInput, ILabel, ISelect, ITextarea } from './types';


export const FieldGroup = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={generateClassName([styles.fieldGroup, className])} {...props} />
);

export const Label = ({
  $backgroundColor = 'light',
  className,
  ...props
}: ILabel) => (
  <label className={generateClassName([styles.label, styles[$backgroundColor], className])} {...props} />
);

export const Description = ({ $backgroundColor = 'light', className, ...props }: IDescription) => (
  <div
    className={generateClassName([
      styles.description,
      styles[$backgroundColor],
      className,
    ])}
    {...props}
  />
);

export const Input = ({ $backgroundColor = 'light', className, hasError, multiple, ...props }: IInput) => (
  <input
    className={generateClassName([
      styles.textarea,
      styles[$backgroundColor],
      hasError && styles.hasError,
      styles.inputBase,
      multiple && styles.multiple,
      className,
    ])}
    {...props}
  />
);

export const Select = ({ $backgroundColor = 'light', className, hasError, multiple, ...props }: ISelect) => (
  <select
    className={generateClassName([
      styles.textarea,
      styles[$backgroundColor],
      hasError && styles.hasError,
      styles.inputBase,
      multiple && styles.multiple,
      className,
    ])}
    {...props}
  />
);

export const Textarea = ({ $backgroundColor = 'light', className, hasError, ...props }: ITextarea) => (
  <textarea
    className={generateClassName([
      styles.textarea,
      styles[$backgroundColor],
      hasError && styles.hasError,
      styles.inputBase,
      className,
    ])}
    {...props}
  />
);

export const Error = ({ className, ...props }: IFormText) => (
  <FormText className={generateClassName([styles.error, className])} {...props} />
);
